import { Avatar, Container, H2, H5 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './Investors.module.scss'

const Investors = ({ title, description, logos }) => (
  <section className={styles.Investors} style={{ backgroundColor: '#14aea5' }}>
    <Container className={styles.ContainerTeam}>
      <div className={styles.Header}>
        {title ? (
          <H2 type="heading" weight="semibold">
            {title}
          </H2>
        ) : null}
        {description ? <H5>{description}</H5> : null}
      </div>
      <div className={styles.Logos}>
        {logos.map(({ logo }, index) => (
          <Avatar key={index} src={logo} alt="logo" width={320} height={120} />
        ))}
      </div>
    </Container>
  </section>
)

Investors.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.object)
}

Investors.defaultProps = {
  title: '',
  description: '',
  logos: []
}

export default Investors
